export default "__VITE_ASSET__f13cfdbd__"